"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.murmur3 = murmur3;
/**
 * MurmurHash3 x86_32 over bytes, all arithmetic wrapping at 2^32. Stored
 * values depend on it (row fingerprints, cell keys of type-changed columns):
 * never change it.
 */
function murmur3(bytes, seed) {
    let h = seed >>> 0;
    const blocks = bytes.length & ~3;
    for (let i = 0; i < blocks; i += 4) {
        let k = bytes[i] |
            (bytes[i + 1] << 8) |
            (bytes[i + 2] << 16) |
            (bytes[i + 3] << 24);
        k = Math.imul(k, 0xcc9e2d51);
        k = (k << 15) | (k >>> 17);
        k = Math.imul(k, 0x1b873593);
        h ^= k;
        h = (h << 13) | (h >>> 19);
        h = (Math.imul(h, 5) + 0xe6546b64) | 0;
    }
    const tail = bytes.length & 3;
    if (tail) {
        let k = 0;
        for (let i = tail - 1; i >= 0; i--)
            k = (k << 8) | bytes[blocks + i];
        k = Math.imul(k, 0xcc9e2d51);
        k = (k << 15) | (k >>> 17);
        k = Math.imul(k, 0x1b873593);
        h ^= k;
    }
    h ^= bytes.length;
    h ^= h >>> 16;
    h = Math.imul(h, 0x85ebca6b);
    h ^= h >>> 13;
    h = Math.imul(h, 0xc2b2ae35);
    h ^= h >>> 16;
    return h >>> 0;
}
